<template>
  <footer id="footer">
    <div class="img">
        <img src="@/assets/images/logo2.png" alt="Grupo MLA">
    </div>
    <div class="container-footer">
      <div class="conmutador">
        <h4 class="footer-title">CONMUTADOR</h4>
        <p class="tel">(5255) 5640 2270</p>
      </div>
      <div class="email">
        <h4 class="footer-title">EMAIL</h4>
        <p class="p-email">info@grupomla.com.mx</p>
      </div>
      <div class="siguenos">
        <h4 class="footer-title">SIGUENOS EN:</h4>
        <div class="redes">
          <a target="_blank" href="https://www.facebook.com/Grupo-MLA-272378032808505/"><span class="facebook"><i class="fab fa-facebook"></i></span></a>
        </div>
      </div>
      <div class="comercio">
        <h4 class="footer-title">NUESTRAS COMERCIALIZADORAS</h4>
        <p><router-link to="/mayra">Frutas Mayra</router-link></p>
        <p><router-link to="/maynekman">Maynekman</router-link></p>
        <p><router-link to="/modernman">Modernman</router-link></p>
        <p><router-link to="/outlandish">Outlandish</router-link></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
#footer {
  margin-top: 15vh;;
  background-color: #f9f9f9;

   .img {
     position: relative;
     top: -70px;
     z-index: 2;


     img {
       width: 200px;
     }
    }

  .container-footer {
    display: flex;
    justify-content: center;
    margin-top: -90px;


    > div {
      margin: 70px 30px;

       > p {
        color: #b4b4b4;
        text-align: start;

        a {
           color: #b4b4b4;
           text-decoration: none;
        }
      }
    }

    .footer-title {
      color: #b4b4b4;
      text-align: start;


    }
    .siguenos {
      .redes {
        display: flex;
        justify-content: space-around;
        font-size: 2em;

        a{
          text-decoration: none;
          color: #b4b4b4;
        }
      }
    }
  }
}
@media screen and (max-width: 600px){
  .container-footer {
    flex-direction: column;
    align-items: center;
  }
  #footer div.container-footer > div {
    margin: 5px 30px;
  }
  #footer div.container-footer > div.conmutador {
    margin-top: 50px;
  }
  #footer div.container-footer .footer-title {
    text-align: center;
    font-size: 2em;
  }
  #footer div.container-footer p {
    font-size: 1.3em !important;
    text-align: center;
  }
}
</style>
